export default __webpack_public_path__ + "static/media/ColorGun.256.6fd1cae4.png";